import { LINK_CHAR } from "./Constants";
import Logger from "../Logger";

import { isDevelopmentEnvironment } from "../estada-config";

const logger = new Logger();

export function copyAllProperties(from?: any, to?: any) {
  if (from && to) {
    for (let i in from) {
      if (i != "className") {
        if (isDevelopmentEnvironment() && to.__proto_ && to.__proto_[i] == undefined) {
          logger.error(`property ${i} undefined in ${to.name}`);
        }
        to[i] = from[i];
      }
    }
  }
  return to;
}

export function copyAllDefinedProperties(from?: any, to?: any) {
  if (from && to) {
    for (let i in from) {
      if (i != "className" && i != "parentId" && i != "projectId") {
        if (from.hasOwnProperty(i)) {
          to[i] = from[i];
        }
      }
    }
  }
  return to;
}

export function saveProperties(from: any = {}, to: any = {}, ...rest: string[]) {
  if (rest.length == 0) {
    if (from && from.getPersistentProperties) {
      rest = from.getPersistentProperties();
    }
  }
  if (from && to) {
    rest.map((name) => {
      if (from[name] != undefined) {
        if (from[name] && from[name].toJSON) {
          to[name] = from[name].toJSON();
        } else {
          to[name] = from[name];
        }
      }
    });
  }
  return to;
}

export function loadProperties(from: any = {}, to: any = {}, ...rest: string[]) {
  if (rest.length == 0) {
    if (to && to.getPersistentProperties) {
      rest = to.getPersistentProperties();
    }
  }
  if (from && to) {
    rest.map((name) => {
      if (from[name] != undefined) {
        if (to[name] && to[name].fromJSON) {
          to[name].fromJSON(from[name], to);
        } else {
          if (name != "className") {
            to[name] = from[name];
          }
        }
      }
    });
  }

  return to;
}

export function copyProperties(from: any = {}, to: any = {}, ...rest: string[]) {
  if (rest.length == 0) {
    if (from && from.getPersistentProperties) {
      rest = from.getPersistentProperties();
    }
    if (to && to.getPersistentProperties) {
      rest = to.getPersistentProperties();
    }
  }
  // return Object.assign(to, from);
  if (from && to) {
    rest.map((name) => {
      if (from[name] != undefined) {
        if (to[name] && to[name].fromJSON) {
          // if (Object.hasOwn(to, name) && to[name].fromJSON) {
          return;
        }
        if (from[name] && from[name].toJSON) {
          // if (Object.hasOwn(from, name) && from[name].toJSON) {
          // if (to[name] && to[name].fromJSON) {
          //   to[name].fromJSON(from[name].toJSON());
          // } else {
          to[name] = from[name].toJSON();
          // }
        } else {
          if (name != "className") {
            // from copy properties of xOldSettings
            // Shallow-clone plain objects so that cancel in SettingsDialog can restore them correctly.
            if (from[name] !== null && typeof from[name] === "object" && !Array.isArray(from[name])) {
              to[name] = { ...from[name] };
            } else {
              to[name] = from[name];
            }
          }
        }
      }
    });
  }

  return to;
}

export function compareProperties(from: any, to: any, ...rest: string[]): string[] {
  let differingProperties = new Array<string>();
  if (from && to) {
    differingProperties = rest.flatMap((name: string) => {
      if (from[name] && from[name].compareTo) {
        const diffs: Array<string> = from[name].compareTo(to[name]);
        if (diffs.length > 0) {
          diffs.unshift(name);
          return diffs;
        } else {
          return [];
        }
      } else if (from[name] != to[name]) {
        return [name];
      } else {
        return [];
      }
    });
  }

  return differingProperties;
}

export function concatMaps<T>(...rest: Map<string, T>[]) {
  const res = new Map<string, T>();
  rest.map((map) => map.forEach((value, key) => res.set(key, value)));
  return res;
}

export async function later(callback: (...rest: any) => any, msDelay: number = 100) {
  return new Promise<any>((resolve) =>
    setTimeout(() => {
      const res = callback();
      resolve(res);
    }, msDelay),
  );
}

export function makeStringSortable(s: string): string {
  const res = s.replace(/\d+/g, function (match) {
    return match.padStart(4, "0");
  });

  // console.log("makeStringSortable", s, res);

  return res;
}

export function sortArrayByProperty<T>(array: Array<T>, propertyName: string): Array<T> {
  let errorFound = false;
  array.sort((a: any, b: any) => {
    try {
      //
      // avoid crash if a[propertyName] or b[propertyName] is undefined
      //
      if (isDevelopmentEnvironment()) {
        if (!errorFound) {
          if (a[propertyName] == undefined || b[propertyName] == undefined) {
            errorFound = true;
            logger.error(new Error(`sortArrayByProperty property undefined ${propertyName}`));
          }
        }
      }

      let nameA = String(a[propertyName] ?? "").toUpperCase(); // ignore upper and lowercase
      let nameB = String(b[propertyName] ?? "").toUpperCase(); // ignore upper and lowercase

      nameA = makeStringSortable(nameA);
      nameB = makeStringSortable(nameB);

      return nameA.localeCompare(nameB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    } catch (ex) {
      logger.error(`a || b undefinded`, a, b, ex);
      return 0;
    }
  });

  return array;
}

export function sortArrayByValueFunction<T>(array: Array<T>, valueFunction: (item: T) => string): Array<T> {
  array.sort((a: any, b: any) => {
    try {
      let nameA = String(valueFunction(a) ?? "").toUpperCase(); // ignore upper and lowercase
      let nameB = String(valueFunction(b) ?? "").toUpperCase(); // ignore upper and lowercase

      nameA = makeStringSortable(nameA);
      nameB = makeStringSortable(nameB);

      return nameA.localeCompare(nameB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    } catch (ex) {
      logger.error(ex);
      return 0;
    }
  });

  return array;
}

export function sortArrayByIntProperty<T>(array: Array<T>, propertyName: string): Array<T> {
  array.sort((a: any, b: any) => {
    const ai = parseInt(a[propertyName]) || 0;
    const bi = parseInt(b[propertyName]) || 0;

    if (ai < bi) {
      return -1;
    }
    if (ai > bi) {
      return 1;
    }
    return 0;
  });

  return array;
}

export async function sleep(milliseconds: number): Promise<boolean> {
  return new Promise((resolve) =>
    setTimeout(() => {
      resolve(true);
    }, milliseconds),
  );
}

export function removeFromArray<T>(array: Array<T>, item: T): boolean {
  const index = array.indexOf(item);
  if (index > -1) {
    array.splice(index, 1);
    return true;
  }

  return false;
}

export function findInMap<T>(map: Map<any, T>, filter: (item: T) => boolean): T | undefined {
  for (const [key, value] of map) {
    if (filter(value)) {
      return value;
    }
  }
  return undefined;
}

export function loadScript(FILE_URL: string): Promise<{ status: boolean; message: string }> {
  const async: boolean = true;
  const type: string = "text/javascript";

  return new Promise<{ status: boolean; message: string }>((resolve, reject) => {
    try {
      const scriptEle = document.createElement("script");
      scriptEle.type = type;
      scriptEle.async = async;
      scriptEle.src = FILE_URL;

      scriptEle.addEventListener("load", (ev) => {
        resolve({ status: true, message: "" });
      });

      scriptEle.addEventListener("error", (ev) => {
        reject({
          status: false,
          message: `Failed to load the script ${FILE_URL}`,
        });
      });

      document.body.appendChild(scriptEle);
    } catch (error) {
      reject(error);
    }
  });
}

function hash_32b_to_16b(val32b: number): number {
  var rightBits = val32b & 0xffff; // Left-most 16 bits
  var leftBits = val32b & 0xffff0000; // Right-most 16 bits

  leftBits = leftBits >>> 16; // Shift the left-most 16 bits to a 16-bit value

  return rightBits ^ leftBits; // XOR the left-most and right-most bits
}

/**
 * Calculate a 32 bit FNV-1a hash
 * Found here: https://gist.github.com/vaiorabbit/5657561
 * Ref.: http://isthe.com/chongo/tech/comp/fnv/
 *
 * @param {string} str the input value
 * @param {boolean} [asString=false] set to true to return the hash value as
 *     8-digit hex string instead of an integer
 * @param {integer} [seed] optionally pass the hash of the previous chunk
 * @returns {integer | string}
 */
function hashFnv32a(str: string, seed: number) {
  /*jshint bitwise:false */
  var i,
    l,
    hval = seed === undefined ? 0x811c9dc5 : seed;

  for (i = 0, l = str.length; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }

  return hval >>> 0;
}

export function stringToShortKey(s: string): string {
  let h = hashFnv32a(s, 23923);
  h = hash_32b_to_16b(h);

  let res = "";
  for (let i = 0; i < 4; i++) {
    res += String.fromCharCode(65 + (h % 24));
    h = Math.floor(h / 24);
  }

  return res;
}

export function getPrefixFromString(name: string): string {
  const matches = name.match(/[a-zA-Z]+/g);
  if (!matches || matches.length <= 1) {
    return "";
  }

  return matches[0];
}

export function getPostfixFromString(name: string): string {
  let i = name.length - 1;
  while (i >= 0 && (name[i] == " " || (name[i] >= "a" && name[i] <= "z") || (name[i] >= "A" && name[i] <= "Z"))) {
    i--;
  }

  return name.substring(i + 1);
}

export function getSizeFromString(name: string): number {
  const matches = Array.from(name.matchAll(/\d+/g));
  if (!matches || matches.length <= 1) {
    return 1;
  }

  const firstMatch = matches[0];
  const lastMatch = matches[matches.length - 1];
  const firstEnd = (firstMatch.index ?? 0) + firstMatch[0].length;
  const lastStart = lastMatch.index ?? 0;
  const between = name.substring(firstEnd, lastStart);

  // If letters are between both numbers without separators like comma or dot,
  // treat this as no valid range.
  if (/[a-zA-Z]/.test(between) && !/[,.;:!?_\-+*/\\()\[\]{}\s]/.test(between)) {
    return 1;
  }

  const a = parseInt(firstMatch[0]);
  const b = parseInt(lastMatch[0]);
  const res = b - a + 1;
  if (res > 0) {
    return res;
  } else {
    return 1;
  }
}

export function getIndexFromString(s: string): number {
  while (s != "" && s.substring(0, 1) > "9") {
    s = s.substring(1);
  }

  if (s.length > 0) {
    return parseInt(s);
  } else return 0;
}

export function getStartIndexFromString(name: string): number {
  let splitted = name.split("-");

  if (splitted.length == 1) {
    splitted = name.split(",");
  }

  return getIndexFromString(splitted[0]);
}

export function formatDate(date?: Date) {
  if (date) {
    var options: Intl.DateTimeFormatOptions = { year: "numeric", month: "numeric", day: "numeric" };
    const locals = undefined; // "en-US"
    return new Date(date).toLocaleDateString(locals, options);
  } else {
    return "--/--";
  }
}

export function formatDateTime(date?: Date) {
  if (date) {
    var options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit", // no itx
      minute: "2-digit", // no itx
    };
    const locals = undefined; // "en-US"
    return new Date(date).toLocaleDateString(locals, options);
  } else {
    return "--/--";
  }
}

export function runAsync(func: () => void) {
  setTimeout(func, 0);
}

const stripNames = ["channel ", "kanal ", "eingang ", "input "]; // no itx

export function nameToShortName(name: string): string {
  //
  // reduce shortname by the word "channel" or "Kanal" etc in the beginning
  //

  /////////////////////////////////////////////////////////////////////////////

  var pDivider = name.search(`[\-,\(,\:,\,,${LINK_CHAR}]`);

  if (pDivider > 0) {
    name = name.substring(0, pDivider);
  } else {
    //
    // für Kanalnamen wie
    //  "A Schalten"
    //  "B Steuerung"
    // ..
    // liefern wir den einzigen Buchstaben als kanalname
    //
    name = name.trim();
    if (name.substring(1, 2) == " ") {
      name = name.substring(0, 1);
      return name;
    }
  }

  //
  // soll aus "Eingang A1" -> "A1" machen
  //
  for (let n of stripNames) {
    if (name.toLocaleLowerCase().startsWith(n)) {
      name = name.substring(n.length).trim();
      return name;
    }
  }

  // if number in name only split after number
  // example: Taste 1 or Taste 1 / 2
  const numbers = name.replace(/^\D+/g, "");
  pDivider = name.lastIndexOf(numbers.slice(-1)) + 1;
  if (pDivider <= 0) {
    //
    // for long names split at the first " ", if exists and after last last number
    //
    pDivider = name.indexOf(" ");
  }

  if (pDivider > 0) {
    name = name.substring(0, pDivider);
  }

  return name;
}

// 1) Präfix: 3 Zeichen aus "Teilstrings"
function makePrefix(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) {
    return "___"; // Fallback für leere Strings // no itx
  }

  // Split an Blanks / Sonderzeichen
  const parts = trimmed.split(/[^A-Za-z0-9ÄÖÜäöüß]+/).filter(Boolean);
  if (parts.length === 0) {
    return "___"; // no itx
  }

  const chars = new Array<string>();

  // a) Erste Buchstaben der Teilstrings
  for (const part of parts) {
    chars.push(part[0]);
    if (chars.length === 3) break;
  }

  // b) Auffüllen mit weiteren Zeichen aus dem letzten Teilstring
  const last = parts[parts.length - 1];
  let i = 1;
  while (chars.length < 3 && last && i < last.length) {
    chars.push(last[i]);
    i++;
  }

  // c) Wenn immer noch < 3, mit '_' auffüllen
  while (chars.length < 3) {
    chars.push("_"); // no itx
  }

  // Groß schreiben für konsistente Sortierung
  return chars.join("").toUpperCase();
}

// 2) Hash: 2 Zeichen aus dem ganzen String
const HASH_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"; // no itx
const HASH_BASE = HASH_ALPHABET.length; // 36

function makeHash(str: string): string {
  let h = 0 >>> 0; // Unsigned 32-bit

  // einfache Hashfunktion
  const norm = str.normalize("NFKD"); // Umlaute etc. etwas stabilisieren // no itx
  for (let i = 0; i < norm.length; i++) {
    h = (h * 131 + norm.charCodeAt(i)) >>> 0; // *131 ist ein klassischer Multiplier
  }

  const c1 = HASH_ALPHABET[h % HASH_BASE];
  const c2 = HASH_ALPHABET[Math.floor(h / HASH_BASE) % HASH_BASE];
  return c1 + c2;
}

// 3) Gesamt-Code: 3 Präfix + 2 Hash = 5 Zeichen
function stringToUniqueShortString(str: string) {
  const prefix = makePrefix(str);
  const hash = makeHash(str);
  return prefix + hash;
}

export function productionAssert(condition: boolean, file: string, line: number) {
  if (!condition) {
    logger.error(`Assert failed: ${file}:${line}`);
  }
}

export function isFloatOrNumberString(value: string): boolean {
  let res = false;
  try {
    if (typeof value === "string") {
      // Accept full numeric strings only (int/float/scientific), no trailing/leading junk.
      res = /^[+-]?(?:\d+\.?\d*|\.\d+)(?:[eE][+-]?\d+)?$/.test(value.trim());
    }
  } catch (ex) {
    logger.error(`isFloatOrNumberString error: ${ex}`);
  }

  return res;
}
